<template>
    <Form @submit="handleForgot" :validation-schema="schema" class="card-primary max-w-sm mx-auto p-4">

        <h2 class="text-lg font-bold mb-4">Réinitialiser le mot de passe</h2>

        <Field name="email" type="email" placeholder="Votre adresse email"
            class="w-full px-3 py-2 border rounded mb-2" />
        <ErrorMessage name="email" class="text-fun text-sm mb-2" />

        <button type="submit" class="btn-primary w-full mt-2" :disabled="loading || sent">
            {{ sent ? "✅ Mail envoyé" : (loading ? "Envoi en cours..." : "Envoyer le lien") }}
        </button>

        <button v-if="sent" type="button" class="btn-accent w-full mt-3" @click="$emit('close')">
            Fermer
        </button>

        <p v-if="message" class="text-sm mt-3 text-center">{{ message }}</p>
    </Form>
</template>

<script setup>
import { Form, Field, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import { ref } from 'vue'
import axios from 'axios'

const loading = ref(false)
const message = ref(null)
const sent = ref(false)

const schema = yup.object({
    email: yup.string().email("Email invalide").required("Email requis")
})

async function handleForgot({ email }) {
    loading.value = true
    message.value = null
    try {
        await axios.post('/api/auth/forgot-password', { email })
        message.value = "📩 Si cet email est enregistré, un lien a été envoyé. Veuillez cliquer sur celui-ci afin de réinitialiser votre mot de passe."
        sent.value = true
    } catch (err) {
        message.value = "📩 Si cet email est enregistré, un lien a été envoyé. Veuillez cliquer sur celui-ci afin de réinitialiser votre mot de passe." // ne jamais dire si email existe
        sent.value = true
    } finally {
        loading.value = false
    }
}
</script>
